import FullLoadingScreen from './FullLoadingScreen';

export default FullLoadingScreen;
